import { Menu, Search } from 'lucide-react';
import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth/useAuth';
import { cn } from '@/lib/utils/cn';
import { Container } from './Container';
import { MobileMenu } from './MobileMenu';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';
import { NAV_LINKS } from './navConfig';

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  return (
    <header className="sticky top-0 z-40 border-b border-line bg-surface/90 backdrop-blur">
      <Container className="flex h-16 items-center justify-between gap-4">
        <Logo />

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                cn(
                  'rounded-md px-3 py-2 text-sm font-medium text-ink/80 transition-colors hover:text-purple-600',
                  isActive && 'text-purple-600',
                )
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            aria-label="Search"
            className="hidden rounded-md p-2 text-ink/70 hover:bg-surface-2 sm:inline-flex"
          >
            <Search className="h-5 w-5" />
          </Link>

          <ThemeToggle />

          <div className="hidden items-center gap-2 md:flex">
            <Button asChild variant="ghost" size="sm">
              <Link to="/get-help">Get Help</Link>
            </Button>
            <Button asChild variant="outline" size="sm">
              <Link to="/join">Join Us</Link>
            </Button>
            <Button asChild variant="secondary" size="sm">
              <Link to="/donate">Donate</Link>
            </Button>
          </div>

          {isAuthenticated ? (
            <UserMenu />
          ) : (
            <Button asChild variant="ghost" size="sm" className="hidden md:inline-flex">
              <Link to="/login">Sign in</Link>
            </Button>
          )}

          <button
            className="rounded-md p-2 text-ink hover:bg-surface-2 lg:hidden"
            aria-label="Open menu"
            onClick={() => setMobileOpen(true)}
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </Container>

      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </header>
  );
}
